// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Regieberichte. Every selector is scoped to .work-reports-page; dialogs get it as rootClassName
   because they render outside the page. */

.work-reports-page .wr-full {
  width: 100%;
}

.work-reports-page .wr-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.work-reports-page .wr-small {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.work-reports-page .wr-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.work-reports-page .wr-empty-text {
  max-width: 460px;
  margin-inline: auto;
}

/* ---- Editor header ---- */
.work-reports-page .wr-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

.work-reports-page .wr-header-title {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex: 1 1 0;
  min-width: 0;
}

.work-reports-page .wr-header-title h4 {
  margin: 0;
  overflow-wrap: anywhere;
}

/* ---- Lines ---- */
.work-reports-page .wr-line {
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
  background: var(--ds-surface);
}

.work-reports-page .wr-line-head {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-2);
}

.work-reports-page .wr-line-figures {
  flex: 1 1 auto;
  text-align: end;
  min-width: 0;
}

.work-reports-page .wr-source {
  margin-inline-start: var(--ds-space-2);
}

.work-reports-page .wr-kind-select {
  min-width: 130px;
}

.work-reports-page .wr-field {
  display: block;
}

.work-reports-page .wr-field-label {
  display: block;
  font-size: 12px;
  color: var(--ds-text-muted);
  margin-bottom: 2px;
}

.work-reports-page .wr-name-input {
  margin-top: var(--ds-space-2);
}

/* ---- Photos ---- */
.work-reports-page .wr-photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: var(--ds-space-3);
}

.work-reports-page .wr-photo-grid figure {
  position: relative;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1, 4px);
}

.work-reports-page .wr-photo-grid .ant-image,
.work-reports-page .wr-photo-grid .ant-image-img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: var(--ds-radius-sm, 6px);
}

.work-reports-page .wr-photo-grid figcaption {
  font-size: 12px;
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

.work-reports-page .wr-photo-remove {
  position: absolute;
  inset-block-start: 4px;
  inset-inline-end: 4px;
  background: var(--ds-surface);
  box-shadow: var(--ds-shadow-sm);
}

/* ---- Totals ---- */
.work-reports-page .wr-totals,
.work-reports-page .wr-preview-totals {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px var(--ds-space-4);
  margin: 0;
}

.work-reports-page .wr-totals dt,
.work-reports-page .wr-preview-totals dt {
  color: var(--ds-text-muted);
}

.work-reports-page .wr-totals dd,
.work-reports-page .wr-preview-totals dd {
  margin: 0;
  text-align: end;
  font-variant-numeric: tabular-nums;
}

.work-reports-page .wr-totals .wr-gross,
.work-reports-page .wr-preview-totals .wr-gross {
  font-weight: 600;
  color: var(--ds-heading);
  border-top: 1px solid var(--ds-border);
  padding-top: 4px;
}

.work-reports-page .wr-warnings {
  margin: 0;
  padding-inline-start: 18px;
}

/* ---- Bottom action bar (phones) ---- */
.work-reports-page .wr-bottom-bar {
  display: none;
}

@media (max-width: 767px) {
  .work-reports-page .wr-header {
    flex-wrap: nowrap;
  }

  .work-reports-page .wr-header-title {
    flex-wrap: wrap;
    gap: var(--ds-space-1);
  }

  .work-reports-page .wr-header-title h4 {
    font-size: 18px;
  }

  .work-reports-page .wr-header:has(.wr-header-actions:not(.wr-hide-phone)) {
    flex-wrap: wrap;
  }

  .work-reports-page .wr-header-actions {
    width: 100%;
  }

  .work-reports-page .wr-bottom-bar {
    display: flex;
    gap: var(--ds-space-2);
    position: sticky;
    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 8px);
    z-index: 5;
    margin-top: var(--ds-space-3);
    padding: var(--ds-space-2);
    border-radius: var(--ds-radius-lg, 14px);
    background: var(--ds-surface);
    box-shadow: var(--ds-shadow-lg);
  }

  .work-reports-page .wr-bottom-bar > .ant-btn-primary {
    flex: 1 1 auto;
  }

  /* The draft actions live in the bottom bar on phones */
  .work-reports-page .wr-header-actions.wr-hide-phone {
    display: none;
  }

  .work-reports-page .wr-section .ant-card-head-wrapper {
    flex-wrap: wrap;
    gap: var(--ds-space-2);
    padding-block: var(--ds-space-2);
  }

  .work-reports-page .wr-section .ant-card-extra {
    margin-inline-start: 0;
  }
}

/* ---- Preview (customer view) ---- */
.work-reports-page .wr-preview-title {
  margin: 0 !important;
}

.work-reports-page .wr-preview-facts {
  margin: var(--ds-space-3) 0;
}

.work-reports-page .wr-preview-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: var(--ds-surface-muted, var(--ds-bg));
  border-radius: var(--ds-radius-sm, 6px);
  padding: var(--ds-space-2) var(--ds-space-3);
}

.work-reports-page .wr-preview-lines {
  list-style: none;
  margin: 0 0 var(--ds-space-2);
  padding: 0;
}

.work-reports-page .wr-preview-lines li {
  padding: var(--ds-space-2) 0;
  border-bottom: 1px solid var(--ds-border);
}

.work-reports-page .wr-preview-line-main,
.work-reports-page .wr-preview-line-sub {
  display: flex;
  justify-content: space-between;
  gap: var(--ds-space-3);
}

.work-reports-page .wr-preview-line-main > span:first-child,
.work-reports-page .wr-preview-line-sub > span:first-child {
  min-width: 0;
  overflow-wrap: anywhere;
}

.work-reports-page .wr-preview-line-sub {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.work-reports-page .wr-preview-totals {
  max-width: 360px;
  margin-inline-start: auto;
  margin-block: var(--ds-space-3);
}

.work-reports-page .wr-preview-terms {
  white-space: pre-wrap;
  margin-top: var(--ds-space-3);
}

.work-reports-page .wr-signed {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  flex-wrap: wrap;
  border-top: 1px solid var(--ds-border);
  padding-top: var(--ds-space-3);
  margin-top: var(--ds-space-3);
}

.work-reports-page .wr-signed img {
  max-height: 72px;
  max-width: 100%;
  background: #fff;
  border-radius: var(--ds-radius-sm, 6px);
}

.work-reports-page .wr-refused {
  margin-top: var(--ds-space-3);
  padding: var(--ds-space-2) var(--ds-space-3);
  border-radius: var(--ds-radius-sm, 6px);
  border: 1px solid var(--ds-warning);
  background: var(--ds-warning-bg);
}

/* ---- Signature ---- */
.work-reports-page .wr-signature-box {
  position: relative;
  border: 2px dashed var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  background: #fff;
  margin-bottom: var(--ds-space-3);
}

.work-reports-page .wr-signature-canvas {
  display: block;
  width: 100%;
  height: 220px;
  touch-action: none;
  cursor: crosshair;
}

.work-reports-page .wr-signature-hint {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9aa7b2;
  font-size: 18px;
  pointer-events: none;
}

.work-reports-page .wr-signature-clear {
  position: absolute;
  inset-block-start: 8px;
  inset-inline-end: 8px;
}

.work-reports-page .wr-location,
.work-reports-page .wr-sign-error {
  margin-top: var(--ds-space-3);
}

.work-reports-page .wr-sign-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-space-2);
  margin-top: var(--ds-space-4);
}

@media (max-width: 767px) {
  .work-reports-page .wr-signature-canvas {
    height: 46vh;
    min-height: 220px;
  }

  .work-reports-page .wr-sign-actions > .ant-btn-primary {
    flex: 1 1 auto;
  }
}

.work-reports-page .wr-link-group {
  width: 100%;
  margin-bottom: var(--ds-space-2);
}

/* ---- Public signing page ---- */
.work-reports-page.wr-public {
  min-height: 100vh;
  background: var(--ds-bg);
  padding: var(--ds-space-4) 16px;
}

.work-reports-page .wr-public-inner {
  max-width: 760px;
  margin: 0 auto;
}

.work-reports-page .wr-public-company {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
}

.work-reports-page .wr-public-company img {
  max-height: 40px;
  max-width: 160px;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/workReports/workReports.css"],"names":[],"mappings":"AAAA;0CAC0C;;AAE1C;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;;EAEE,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iEAAiE;IACjE,UAAU;IACV,6BAA6B;IAC7B,0BAA0B;IAC1B,wCAAwC;IACxC,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,cAAc;EAChB;;EAEA,uDAAuD;EACvD;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,iDAAiD;EACjD,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,uCAAuC;EACvC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* Regieberichte. Every selector is scoped to .work-reports-page; dialogs get it as rootClassName\n   because they render outside the page. */\n\n.work-reports-page .wr-full {\n  width: 100%;\n}\n\n.work-reports-page .wr-num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.work-reports-page .wr-small {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.work-reports-page .wr-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n\n.work-reports-page .wr-empty-text {\n  max-width: 460px;\n  margin-inline: auto;\n}\n\n/* ---- Editor header ---- */\n.work-reports-page .wr-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n.work-reports-page .wr-header-title {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.work-reports-page .wr-header-title h4 {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n/* ---- Lines ---- */\n.work-reports-page .wr-line {\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n  background: var(--ds-surface);\n}\n\n.work-reports-page .wr-line-head {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-2);\n}\n\n.work-reports-page .wr-line-figures {\n  flex: 1 1 auto;\n  text-align: end;\n  min-width: 0;\n}\n\n.work-reports-page .wr-source {\n  margin-inline-start: var(--ds-space-2);\n}\n\n.work-reports-page .wr-kind-select {\n  min-width: 130px;\n}\n\n.work-reports-page .wr-field {\n  display: block;\n}\n\n.work-reports-page .wr-field-label {\n  display: block;\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  margin-bottom: 2px;\n}\n\n.work-reports-page .wr-name-input {\n  margin-top: var(--ds-space-2);\n}\n\n/* ---- Photos ---- */\n.work-reports-page .wr-photo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: var(--ds-space-3);\n}\n\n.work-reports-page .wr-photo-grid figure {\n  position: relative;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1, 4px);\n}\n\n.work-reports-page .wr-photo-grid .ant-image,\n.work-reports-page .wr-photo-grid .ant-image-img {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: var(--ds-radius-sm, 6px);\n}\n\n.work-reports-page .wr-photo-grid figcaption {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n.work-reports-page .wr-photo-remove {\n  position: absolute;\n  inset-block-start: 4px;\n  inset-inline-end: 4px;\n  background: var(--ds-surface);\n  box-shadow: var(--ds-shadow-sm);\n}\n\n/* ---- Totals ---- */\n.work-reports-page .wr-totals,\n.work-reports-page .wr-preview-totals {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 4px var(--ds-space-4);\n  margin: 0;\n}\n\n.work-reports-page .wr-totals dt,\n.work-reports-page .wr-preview-totals dt {\n  color: var(--ds-text-muted);\n}\n\n.work-reports-page .wr-totals dd,\n.work-reports-page .wr-preview-totals dd {\n  margin: 0;\n  text-align: end;\n  font-variant-numeric: tabular-nums;\n}\n\n.work-reports-page .wr-totals .wr-gross,\n.work-reports-page .wr-preview-totals .wr-gross {\n  font-weight: 600;\n  color: var(--ds-heading);\n  border-top: 1px solid var(--ds-border);\n  padding-top: 4px;\n}\n\n.work-reports-page .wr-warnings {\n  margin: 0;\n  padding-inline-start: 18px;\n}\n\n/* ---- Bottom action bar (phones) ---- */\n.work-reports-page .wr-bottom-bar {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .work-reports-page .wr-header {\n    flex-wrap: nowrap;\n  }\n\n  .work-reports-page .wr-header-title {\n    flex-wrap: wrap;\n    gap: var(--ds-space-1);\n  }\n\n  .work-reports-page .wr-header-title h4 {\n    font-size: 18px;\n  }\n\n  .work-reports-page .wr-header:has(.wr-header-actions:not(.wr-hide-phone)) {\n    flex-wrap: wrap;\n  }\n\n  .work-reports-page .wr-header-actions {\n    width: 100%;\n  }\n\n  .work-reports-page .wr-bottom-bar {\n    display: flex;\n    gap: var(--ds-space-2);\n    position: sticky;\n    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 8px);\n    z-index: 5;\n    margin-top: var(--ds-space-3);\n    padding: var(--ds-space-2);\n    border-radius: var(--ds-radius-lg, 14px);\n    background: var(--ds-surface);\n    box-shadow: var(--ds-shadow-lg);\n  }\n\n  .work-reports-page .wr-bottom-bar > .ant-btn-primary {\n    flex: 1 1 auto;\n  }\n\n  /* The draft actions live in the bottom bar on phones */\n  .work-reports-page .wr-header-actions.wr-hide-phone {\n    display: none;\n  }\n\n  .work-reports-page .wr-section .ant-card-head-wrapper {\n    flex-wrap: wrap;\n    gap: var(--ds-space-2);\n    padding-block: var(--ds-space-2);\n  }\n\n  .work-reports-page .wr-section .ant-card-extra {\n    margin-inline-start: 0;\n  }\n}\n\n/* ---- Preview (customer view) ---- */\n.work-reports-page .wr-preview-title {\n  margin: 0 !important;\n}\n\n.work-reports-page .wr-preview-facts {\n  margin: var(--ds-space-3) 0;\n}\n\n.work-reports-page .wr-preview-text {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  background: var(--ds-surface-muted, var(--ds-bg));\n  border-radius: var(--ds-radius-sm, 6px);\n  padding: var(--ds-space-2) var(--ds-space-3);\n}\n\n.work-reports-page .wr-preview-lines {\n  list-style: none;\n  margin: 0 0 var(--ds-space-2);\n  padding: 0;\n}\n\n.work-reports-page .wr-preview-lines li {\n  padding: var(--ds-space-2) 0;\n  border-bottom: 1px solid var(--ds-border);\n}\n\n.work-reports-page .wr-preview-line-main,\n.work-reports-page .wr-preview-line-sub {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n}\n\n.work-reports-page .wr-preview-line-main > span:first-child,\n.work-reports-page .wr-preview-line-sub > span:first-child {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.work-reports-page .wr-preview-line-sub {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.work-reports-page .wr-preview-totals {\n  max-width: 360px;\n  margin-inline-start: auto;\n  margin-block: var(--ds-space-3);\n}\n\n.work-reports-page .wr-preview-terms {\n  white-space: pre-wrap;\n  margin-top: var(--ds-space-3);\n}\n\n.work-reports-page .wr-signed {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n  flex-wrap: wrap;\n  border-top: 1px solid var(--ds-border);\n  padding-top: var(--ds-space-3);\n  margin-top: var(--ds-space-3);\n}\n\n.work-reports-page .wr-signed img {\n  max-height: 72px;\n  max-width: 100%;\n  background: #fff;\n  border-radius: var(--ds-radius-sm, 6px);\n}\n\n.work-reports-page .wr-refused {\n  margin-top: var(--ds-space-3);\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border-radius: var(--ds-radius-sm, 6px);\n  border: 1px solid var(--ds-warning);\n  background: var(--ds-warning-bg);\n}\n\n/* ---- Signature ---- */\n.work-reports-page .wr-signature-box {\n  position: relative;\n  border: 2px dashed var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  background: #fff;\n  margin-bottom: var(--ds-space-3);\n}\n\n.work-reports-page .wr-signature-canvas {\n  display: block;\n  width: 100%;\n  height: 220px;\n  touch-action: none;\n  cursor: crosshair;\n}\n\n.work-reports-page .wr-signature-hint {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9aa7b2;\n  font-size: 18px;\n  pointer-events: none;\n}\n\n.work-reports-page .wr-signature-clear {\n  position: absolute;\n  inset-block-start: 8px;\n  inset-inline-end: 8px;\n}\n\n.work-reports-page .wr-location,\n.work-reports-page .wr-sign-error {\n  margin-top: var(--ds-space-3);\n}\n\n.work-reports-page .wr-sign-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--ds-space-2);\n  margin-top: var(--ds-space-4);\n}\n\n@media (max-width: 767px) {\n  .work-reports-page .wr-signature-canvas {\n    height: 46vh;\n    min-height: 220px;\n  }\n\n  .work-reports-page .wr-sign-actions > .ant-btn-primary {\n    flex: 1 1 auto;\n  }\n}\n\n.work-reports-page .wr-link-group {\n  width: 100%;\n  margin-bottom: var(--ds-space-2);\n}\n\n/* ---- Public signing page ---- */\n.work-reports-page.wr-public {\n  min-height: 100vh;\n  background: var(--ds-bg);\n  padding: var(--ds-space-4) 16px;\n}\n\n.work-reports-page .wr-public-inner {\n  max-width: 760px;\n  margin: 0 auto;\n}\n\n.work-reports-page .wr-public-company {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n}\n\n.work-reports-page .wr-public-company img {\n  max-height: 40px;\n  max-width: 160px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
